import { createApp } from 'vue';

// Initialize Faro (before Vue app creation for early error capture)
if (import.meta.env.VITE_NEW_RELIC_DISABLED !== "true") {
    const webSdkScript = document.createElement('script');
    webSdkScript.setAttribute('type', 'text/javascript');

    // fetch the latest 1.x.x version of the Web-SDK from the CDN
    webSdkScript.src = "https://unpkg.com/@grafana/faro-web-sdk@1/dist/bundle/faro-web-sdk.iife.js";
    webSdkScript.onload = () => {
        // @ts-ignore
        window.GrafanaFaroWebSdk.initializeFaro({
            url: "https://faro-collector-prod-us-east-2.grafana.net/collect/742265ae8057c45556d94e79578297f6",
            app: {
                name: "YourMailroom.UI.Customer",
                version: "1.0.0",
                environment: "production",
            },
            // Session tracking
            sessionTracking: {
                enabled: true,
                persistent: true,
            },

        });

        // Load instrumentations at the onLoad event of the web-SDK and after the above configuration.
        // This is important because we need to ensure that the Web-SDK has been loaded and initialized before we add further instruments!
        const webTracingScript = document.createElement("script");
        webTracingScript.setAttribute('type', 'text/javascript');

        // fetch the latest 1.x.x version of the Web Tracing package from the CDN
        webTracingScript.src = "https://unpkg.com/@grafana/faro-web-tracing@1/dist/bundle/faro-web-tracing.iife.js";

        // Initialize, configure (if necessary) and add the the new instrumentation to the already loaded and configured Web-SDK.
        webTracingScript.onload = () => {
            // @ts-ignore
            window.GrafanaFaroWebSdk.faro.instrumentations.add(
                // @ts-ignore
                new window.GrafanaFaroWebTracing.TracingInstrumentation()
            );
        };

        // Append the Web Tracing script script tag to the HTML page
        document.head.appendChild(webTracingScript);
    };

    // Append the Web-SDK script script tag to the HTML page
    document.head.appendChild(webSdkScript);
}


import App from './App.vue';
import router from './router';

import "./permission"; // permission control

import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

const MyPreset = definePreset(Aura, {
    //Your customizations, see the following sections for examples
    primitive: {
        //700 - #000664
        mailroom: {
            50: 'hsl(236,100%,90%)',//'#eff6ff', 
            100: 'hsl(236,100%,80%)',//'#dbeafe', 
            200: 'hsl(236,100%,65%)',//'#bfdbfe', 
            300: 'hsl(236,100%,50%)',//'#93c5fd', 
            400: 'hsl(236,100%,45%)',//'#60a5fa', 
            500: 'hsl(236,100%,30%)',//'#3b82f6', 
            600: 'hsl(236,100%,25%)',//'#2563eb', 
            700: 'hsl(236,100%,20%)',//'#1d4ed8', 
            800: 'hsl(236,100%,15%)',//'#1e40af', 
            900: 'hsl(236,100%,10%)',//'#1e3a8a', 
            950: 'hsl(236,100%,05%)',//'#172554' 
        },
    },
    semantic: {
        primary: {
             50: '{mailroom.50}',
            100: '{mailroom.100}',
            200: '{mailroom.200}',
            300: '{mailroom.300}',
            400: '{mailroom.400}',
            500: '{mailroom.500}',
            600: '{mailroom.600}',
            700: '{mailroom.700}',
            800: '{mailroom.800}',
            900: '{mailroom.900}',
            950: '{mailroom.950}'
        },
        
    },
});

import '@/assets/styles.scss';
import '@/assets/tailwind.css';

const app = createApp(App);

app.use(router);

// Google Ads Integration (gtag.js)
const googleAdsEnabled = import.meta.env.VITE_GOOGLE_ADS_ENABLED === 'true';
const googleAdsId = import.meta.env.VITE_GOOGLE_ADS_ID;

if (googleAdsEnabled && googleAdsId) {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    // Define gtag function
    function gtag(...args: any[]) {
        window.dataLayer!.push(args);
    }
    // @ts-ignore
    window.gtag = gtag;

    // Load Google Ads gtag.js script
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`;
    document.head.appendChild(gtagScript);

    gtag('js', new Date());
    gtag('config', googleAdsId);

    console.log(`Google Ads initialized with ID: ${googleAdsId}`);
} else {
    console.log('Google Ads is disabled');
}

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: '.app-dark'
        }
    }
});
app.use(ToastService);
app.use(ConfirmationService);

app.mount('#app');
